import { ActivitiesAggrigatorModel } from "./activities-aggrigator-model";

export class ActivityPluseAggrigatorModel {
        mainFeed!: ActivitiesAggrigatorModel;
        otherFeeds!: ActivitiesAggrigatorModel[];
}